import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Order from '../../../smoothr-web-app-core/models/Order';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { AdyenCredentials } from '../../../smoothr-web-app-core/models/Venue';
import { PaySessionStatistics } from '../../../smoothr-web-app-core/models/PaySessionStatistics';
import { PaymentHandler } from '../../../smoothr-web-app-core/utils/PaymentHandler';

export interface ApplePayModalResult {
	applePaySession: ApplePaySession;
	tipValue: number;
}

@Component({
	standalone: false,
	selector: 'app-apple-pay-modal',
	templateUrl: './apple-pay-modal.component.html',
	styleUrls: ['./apple-pay-modal.component.scss'],
})
export class ApplePayModalComponent implements OnInit {
	@Input() order: Order | null = null;

	totalPrice = 0;
	formattedTotalPrice = '';
	formattedTips = '';
	paySessionStatistics: PaySessionStatistics | null = null;

	loading = true;

	private repositoryService = inject(RepositoryService);
	private adyenCredentials: AdyenCredentials | null = null;

	private modalCtrl: ModalController = inject(ModalController);

	constructor() {}

	get formattedSelected() {
		return this.repositoryService.currencyFormat.format(this.paySessionStatistics?.selectedTotalPrice ?? 0);
	}

	static async show(
		modalCtrl: ModalController,
		paySessionStatistics: PaySessionStatistics | null,
		order: Order,
		adyenCredentials: AdyenCredentials
	): Promise<ApplePayModalResult> {
		const modal = await modalCtrl.create({
			component: ApplePayModalComponent,
			cssClass: 'payment-sheet-modal',
			componentProps: {
				order,
				itemCount: order.checkoutOrderedArticles.length,
				adyenCredentials,
				paySessionStatistics,
			},
		});

		await modal.present();
		const { data } = await modal.onDidDismiss();
		return data;
	}

	ngOnInit() {
		this.loadPayment();
	}

	async loadPayment() {
		await this.paymentMethodApplePayAdyen();
		this.loading = false;
	}

	async paymentMethodApplePayAdyen() {
		this.loading = true;
		this.reloadPrices();
		this.loading = false;
	}

	async confirmButton() {
		const applePaySession = PaymentHandler.generateApplePaySession(this.order!, this.totalPrice, this.adyenCredentials!);
		if (!applePaySession) {
			console.error('No cardCheckout found');
			return;
		}
		console.log('applePaySession', applePaySession);

		const tipValue = this.paySessionStatistics?.tipsValue ?? 0;
		await this.modalCtrl.dismiss({
			applePaySession,
			tipValue,
		});
	}

	reloadPrices() {
		const selectedTotalPrice = this.paySessionStatistics?.selectedTotalPrice ?? 0;
		const tipValue = this.paySessionStatistics?.tipsValue ?? 0;
		this.totalPrice = selectedTotalPrice;
		this.formattedTotalPrice = this.repositoryService.currencyFormat.format(selectedTotalPrice);
		this.formattedTips = this.repositoryService.currencyFormat.format(tipValue);
	}

	close() {
		this.modalCtrl.dismiss();
	}
}
